import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { UserEventHistoryService } from '../services/user-event-history.service';

@Injectable()
export class EventHistoryInterceptor implements HttpInterceptor {
  constructor(private readonly userEventHistoryService: UserEventHistoryService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.headers.has('X-Skip-Event-History')) {
      return next.handle(request);
    }

    if (!this.shouldTrack(request.url)) {
      return next.handle(request);
    }

    const method = request.method.toUpperCase();
    const endpoint = this.toEndpoint(request.url);
    const startedAt = Date.now();

    this.userEventHistoryService.trackEvent(
      `HTTP_${method}`,
      endpoint,
      'Request started',
      { method, status: 'STARTED' }
    );

    return next.handle(request).pipe(
      tap({
        next: (event: HttpEvent<unknown>) => {
          if (!(event instanceof HttpResponse)) {
            return;
          }
          this.userEventHistoryService.trackEvent(`HTTP_${method}`, endpoint, 'Request success', {
            method,
            status: 'SUCCESS',
            statusCode: event.status,
            durationMs: Date.now() - startedAt
          });
        },
        error: (error: HttpErrorResponse) => {
          this.userEventHistoryService.trackEvent(
            `HTTP_${method}`,
            endpoint,
            error?.message || 'Request failed',
            {
              method,
              status: 'FAILED',
              statusCode: error?.status ?? null,
              durationMs: Date.now() - startedAt
            }
          );
        }
      })
    );
  }

  private shouldTrack(url: string): boolean {
    return url.startsWith(environment.APIUrl);
  }

  private toEndpoint(url: string): string {
    return url.replace(environment.APIUrl, '') || url;
  }
}
